// extracted by mini-css-extract-plugin
export default {"coins":"Isl1ZaY_UWOBHGjfXDP_","buttonsInRow":"mPPavoO73HW6k9k3jhQz","button":"sqdBLCE3PCmg4Mwmb71q","link":"ZcjCHkgQK4PmqkCo_dEo"};